// import external dependencies
import 'jquery'

// import everything from autoload
import './autoload/_bootstrap.js'; import './autoload/_emptySpace.js'; import './autoload/_hyphenate.js'; import './autoload/_object-fit.js' // eslint-disable-line

// import vc-elements javascript files
import '../vc_elements/_new/main.js'; import '../vc_elements/button/main.js'; import '../vc_elements/color_boxes/main.js'; import '../vc_elements/color_circles/main.js'; import '../vc_elements/download/main.js'; import '../vc_elements/econtribute_structure/main.js'; import '../vc_elements/googlemap/main.js'; import '../vc_elements/hero/main.js'; import '../vc_elements/home_teasers/main.js'; import '../vc_elements/infografic/main.js'; import '../vc_elements/jobs/main.js'; import '../vc_elements/locations/main.js'; import '../vc_elements/percent_infographic/main.js'; import '../vc_elements/photo_gallery/main.js'; import '../vc_elements/research_areas/main.js'; import '../vc_elements/research_seminar_list_by_term/main.js'; import '../vc_elements/research_seminar_list/main.js'; import '../vc_elements/template_element/main.js'; import '../vc_elements/text_slider_container/main.js' // eslint-disable-line

// import react habitat and react components
import './init/react'

// import local dependencies
import Router from './util/Router'
import common from './routes/common'

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
})

// Load Events
jQuery(document).ready(() => routes.loadEvents())
